import { render, staticRenderFns } from "./BindYandex.vue?vue&type=template&id=c15f9356&scoped=true&"
import script from "./BindYandex.vue?vue&type=script&lang=js&"
export * from "./BindYandex.vue?vue&type=script&lang=js&"
import style0 from "./BindYandex.vue?vue&type=style&index=0&id=c15f9356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15f9356",
  null
  
)

export default component.exports